import React from "react";
import PropTypes from "prop-types";

import { Form, Input, Button, ModalView } from "../../simple";
import SVG from "../../SVG";
import {
  validate as validator,
  validationRules
} from "../../../helpers/validate";
// import { formatDate } from "../../../helpers/formatter";

function validate(value, name) {
  if (name !== "vertical") {
    const result = validator(value, validationRules.exist);
    return result;
  }
  return name === "vertical";
}

export default class ClientForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: props.data.name || ""
      },
      validation: {
        name: false || !!props.fieldErrors.name
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    this.setState(({ data, validation }) => ({
      data: { ...data, [name]: value },
      validation: {
        ...validation,
        [name]: !validate(value, name)
      }
    }));
  }

  handleSubmit(evt) {
    const { data } = this.state;
    const { data: propData } = this.props;

    evt.preventDefault();
    const submitData = {
      ...data
    };
    /* eslint-disable */
    if (propData.id) {
      submitData.id = propData.id;
    }
    /* eslint-enable */
    this.props.handleSubmit(submitData);
  }

  render() {
    const {
      data: { name },
      validation
    } = this.state;
    const { data, fieldErrors } = this.props;
    const isSubmitDisabled = !(!!name && !validation.name);
    const isEdit = !!Object.keys(data).length;
    const title = isEdit ? "Edit client" : "Add new client";

    return (
      <Form onSubmit={this.handleSubmit} className="client-form">
        <h2 className="title">{title}</h2>
        {/* {isEdit && (
          <div className="create-info">
            <span className="creator">
              <SVG.Client className="user-icon" />
              {data.createdBy}
            </span>
            <div className="delimiter"></div>
            <span className="date">{formatDate(data.createdAt)}</span>
          </div>
        )} */}
        <div className="mt-5 mb-5">
          <Input
            type="text"
            value={name}
            label="Name"
            name="name"
            placeholder="Name"
            invalid={validation.name}
            handleChange={this.handleChange}
            required
            fieldError={fieldErrors.name || "Please, provide a valid name"}
          />
        </div>
        <Button
          type="submit"
          className="button justify-content-center"
          disabled={isSubmitDisabled}
        >
          Save
          <SVG.Arrow className="icon" />
        </Button>
      </Form>
    );
  }
}

ClientForm.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    createdBy: PropTypes.string,
    createdAt: PropTypes.string,
    vertical: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  fieldErrors: PropTypes.shape({
    name: PropTypes.string,
    verticalId: PropTypes.string
  }),
  handleSubmit: PropTypes.func.isRequired
};

ClientForm.defaultProps = {
  data: {},
  fieldErrors: {
    name: ""
  }
};

export function ModalClientForm(props) {
  const {
    changeModalState,
    isOpen,
    data,
    verticals,
    handleSubmit,
    ...restProps
  } = props;
  return (
    <ModalView
      toggle={changeModalState}
      handleClose={changeModalState}
      isOpen={isOpen}
      {...restProps}
    >
      <ClientForm
        data={data}
        verticals={verticals}
        handleSubmit={handleSubmit}
      />
    </ModalView>
  );
}

ModalClientForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  verticals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    createdBy: PropTypes.string,
    createdAt: PropTypes.string
  }),
  changeModalState: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
};

ModalClientForm.defaultProps = {
  data: {}
};
